/**
 * Builds the request body for POST /login with email and password.
 *
 * @param {string} email
 * @param {string} password
 * @returns {Object} Login request body
 */
export const buildLoginWithEmailAndPassword = (email, password) => ({
  email,
  password,
  includeToken: true,
  includeSecret: true,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
});

export default { buildLoginWithEmailAndPassword };
